/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from '@express-labs/raven-ui';

import { showCta } from '../../../../../../helpers/offersModalsHelpers/offersModalsHelpers';
import AddCodeButton from '../AddCodeButton';
import s from './OffersModal.module.scss';

function OffersModalDetail({ offer, back, appliedCode }) {
  const detailsImage = offer.details_image && offer.details_image.url;
  const imageStyle = {
    backgroundImage: `url(${detailsImage})`,
    backgroundPosition: 'center',
    maxWidth: '100%',
  };
  const promoCodeAdded = !!appliedCode && appliedCode === offer.crm_code;
  const showCta1 = showCta(offer.cta_1);
  const showCta2 = showCta(offer.cta_2);
  return (
    <div className={s.offerContainer}>
      <div className={s.offerDetailContainer}>
        <div>
          <button
            type="button"
            className={s.backToOffersButton}
            aria-expanded
            aria-label="Back to all offers"
            onClick={back}
          >
            <span className={s.backButton}>
              <Icon icon="arrowBack" />
            </span>
            {' '}
            <span className={s.backText}>Back to all Offers</span>
            <span className={s.backTextMobile}>Back</span>
          </button>
        </div>
        <div className={s.offerDetailTitle}>Today&#39;s Offer</div>
      </div>
      <div className={s.offerDetailSubContainer}>
        <div className={s.offerContent}>
          <div style={imageStyle} className={s.offerDetailImage} />
          <div className={s.offerDetailText}>
            <p className={s.offerDetailPercentage}>{offer.subheading}</p>
            <p className={s.offerDetailDescription}>{offer.description}</p>
            <p className={s.offerDetailDescription}>
              {offer.crm_code && (
                <AddCodeButton crmCode={offer.crm_code} promoCodeAdded={promoCodeAdded} />
              )}
              {showCta1 && (
                <Button
                  as="a"
                  theme="dark"
                  size="small"
                  href={offer.cta_1.href}
                  className={s.linkButton}
                >
                  {offer.cta_1.title}
                </Button>
              )}
              {showCta2 && (
                <Button
                  as="a"
                  theme="dark"
                  size="mall"
                  href={offer.cta_2.href}
                  className={s.linkButton}
                >
                  {offer.cta_2.title}
                </Button>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

OffersModalDetail.propTypes = {
  offer: PropTypes.shape({
    crm_code: PropTypes.string,
    cta_1: {
      title: PropTypes.string,
    },
    cta_2: {
      title: PropTypes.string,
    },
    details_image: {
      url: PropTypes.string,
    },
    description: PropTypes.string,
    legal_text: PropTypes.string,
    title: PropTypes.string,
    subheading: PropTypes.string,
  }),
  back: PropTypes.func,
  appliedCode: PropTypes.string,
};

export default OffersModalDetail;
